export const charset7Bit = [
  "@",
  "£",
  "$",
  "¥",
  "è",
  "é",
  "ù",
  "ì",
  "ò",
  "Ç",
  "\n",
  "Ø",
  "ø",
  "\r",
  "Å",
  "å",
  "Δ",
  "_",
  "Φ",
  "Γ",
  "Λ",
  "Ω",
  "Π",
  "Ψ",
  "Σ",
  "Θ",
  "Ξ",
  "Æ",
  "æ",
  "ß",
  "É",
  " ",
  "!",
  '"',
  "#",
  "¤",
  "%",
  "‘",
  "&",
  "'",
  "(",
  ")",
  "*",
  "+",
  ",",
  "-",
  ".",
  "/",
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  ":",
  ";",
  "<",
  "=",
  ">",
  "?",
  "¡",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "Ä",
  "Ö",
  "Ñ",
  "Ü",
  "§",
  "¿",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "ä",
  "ö",
  "ñ",
  "ü",
  "à",
];

export const extendedCharset7Bit = [
  "\f",
  "<FF>",
  "{",
  "}",
  "\\",
  "[",
  "~",
  "]",
  "|",
  "€",
  "^",
];

const yyyyMMdd = /^\d{4}(-)(((0)\d)|((1)[0-2]))(-)([0-2]\d|(3)[0-1])$/i;
const MMdd = /^(((0)\d)|((1)[0-2]))(-)([0-2]\d|(3)[0-1])$/i;
const HHmmss = /^(((0)\d)|((1)\d)|((2)[0-3]))(:)(([0-5]\d))(:)(([0-5]\d))$/i;
const HHmm = /^(((0)\d)|((1)\d)|((2)[0-3]))(:)(([0-5]\d))$/i;

export const DateTimeFormats = {
  yyyyMMdd,
  MMdd,
  HHmmss,
  HHmm,
};

export const StepperConstants = {
  CURRENT: "current",
  UPCOMING: "upcoming",
  COMPLETE: "complete",
};

export enum ACCESS_TYPE {
  READ_ONLY = "READ_ONLY",
  READ_WRITE = "READ_WRITE",
}

export const ACCESS_TYPE_LABEL: Record<ACCESS_TYPE, string> = {
  [ACCESS_TYPE.READ_ONLY]: "Read Only",
  [ACCESS_TYPE.READ_WRITE]: "Read Write",
};
